import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Layout } from './components/layout';
import {
  Overview,
  Identities,
  HumanIdentities,
  NonHumanIdentities,
  Integrations,
  Policies,
  AuthActivity,
  AuthEventsPage,
  Login,
  TenantInfo,
  Visuals
} from './pages';
import UserAccessManagement from './pages/UserDetails/UserDetails';
import Navbar from './components/layout/Navbar/Navbar';
import './App.css';
import { ProtectRoute } from './context/ProtectRoute';
import AdapidMFA from './pages/AdapIdMFA/AdapIdMFa';
import { useTheme } from './context/ThemeContext';

/**
 * Protected Layout - shown only when user is logged in
 * Includes Navbar and Layout with sidebar
 */
const ProtectedLayout = () => (
  <>
    <Navbar />
    <Layout>
      <Outlet />
    </Layout>
  </>
);

/**
 * Public Layout - shown for login page
 * No navbar or sidebar
 */
const PublicLayout = () => (
  <Outlet />
);

/**
 * App Component
 * Handles all routing with proper authentication guards
 */
function App() {
  const { isDark } = useTheme();
  return (
    <div className={`app ${isDark ? 'dark-theme' : ''}`}>
      <Routes>
        {/* ═══════════════════════════════════════════════ */}
        {/* PUBLIC ROUTES - No authentication required      */}
        {/* ═══════════════════════════════════════════════ */}
        <Route element={<PublicLayout />}>
          <Route path="/login" element={<Login />} />
        </Route>

        {/* ═══════════════════════════════════════════════ */}
        {/* PROTECTED ROUTES - Authentication required      */}
        {/* ═══════════════════════════════════════════════ */}
        <Route element={<ProtectRoute />}>
          <Route element={<ProtectedLayout />}>

            {/* Dashboard */}
            <Route path="/overview" element={<Overview />} />

            {/* Identities Module */}
            <Route path="/identities" element={<Identities />} />
            <Route path="/identities/all" element={<Identities />} />
            <Route path="/identities/human" element={<HumanIdentities />} />
            <Route path="/identities/non-human" element={<NonHumanIdentities />} />
            <Route
              path="/identities/applications"
              element={<NonHumanIdentities type="application" />}
            />
            <Route
              path="/identities/service-principals"
              element={<NonHumanIdentities type="service-principal" />}
            />
            <Route
              path="/identities/managed-identities"
              element={<NonHumanIdentities type="managed-identity" />}
            />

            {/* Other Modules */}
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/auth-activity" element={<AuthActivity />} />
            <Route path="/auth-events" element={<AuthEventsPage />} />
            <Route path="/user-access-management" element={<UserAccessManagement />} />
            <Route path="/tenant-info" element={<TenantInfo />} />
            <Route path="/visuals" element={<Visuals/>} />
            <Route path="/adapid-mfa" element ={<AdapidMFA />} />
          </Route>
        </Route>

        {/* ═══════════════════════════════════════════════ */}
        {/* Catch-all Route — redirect to login              */}
        {/* ═══════════════════════════════════════════════ */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
}

export default App;